import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  .__json-pretty__ {\n    width: 100%;\n    padding: 25px;\n    line-height: 1.3;\n    color: rgba(248, 248, 242, 1);\n    background: #1e1e1e;\n    overflow: auto;\n  }\n  .__json-key__ {\n    color: #ffffff;\n  }\n  .__json-value__ {\n    color: #ae81ff;\n  }\n\n  .__json-string__ {\n    color: #e6db74;\n  }\n  .__json-boolean__ {\n    color: #f92672;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import styled from "styled-components";
import JSONPretty from "react-json-pretty";
const JsonContainer = styled.div.withConfig({
    componentId: "sc-87c2f973-0"
})(_templateObject());
export const PrettyJson = (param)=>/*#__PURE__*/ {
    let { value  } = param;
    return _jsx(JsonContainer, {
        children: /*#__PURE__*/ _jsx(JSONPretty, {
            data: value
        })
    });
};
